import Script from "next/script"

const courseDataToSchema = (data, courseId) => {
  const course = data.courses.filter((course) => course.id == courseId)[0]

  const schema = (({ name, description, courseInstances }) => ({
    name,
    description,
    courseInstances,
  }))(course)

  schema["@context"] = "https://schema.org"
  schema["@type"] = "Course"
  schema["provider"] = {
    "@type": "Organization",
    name: "Pirmas kodas",
    sameAs: "https://pirmaskodas.lt",
  }
  return schema
}

const schemaElementFromSchema = (schema) => (
  <Script
    id={schema.name}
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
  ></Script>
)

function orderByOrder(a, b) {
  if (a.order < b.order) {
    return -1
  }
  if (a.order > b.order) {
    return 1
  }
  return 0
}

export { courseDataToSchema, schemaElementFromSchema, orderByOrder }
